import theme from '@/style';
import {View} from 'react-native';
import BetsItem, {type BetsItemTarget} from '../component/bets-item';
import BetsLabel from '../component/bets-label';
import React from 'react';
import {
  LotteryMode,
  MixBetOpt,
  CartListItem,
  roundTicketHisType,
} from '../mix-lottery-service';
import Text from '@/components/basic/text';
import {padZero} from '@/utils';

type BetTriggerTarget = View | BetsItemTarget;
// import globalStore from '@/services/global.state';
// import {useTranslation} from 'react-i18next';
export interface BetsTypeItemProps {
  type: 'A' | 'B' | 'C' | 'D';
  options: MixBetOpt[];
  isDigit: boolean;
  isSingle: boolean;
  mode: LotteryMode;
  onBets?: (
    item: MixBetOpt & {betItem?: number},
    view?: BetTriggerTarget,
  ) => void;
  cartList: CartListItem[];
  currentPrize: number;
  cartListShadow?: CartListItem[];
  index?: number;
  rowIndex?: number;
  hasSelected?: roundTicketHisType[];
  disabledAll?: boolean;
}

const DEFAULT = ['A', 'B', 'C', 'D'];
const SIDE_TYPE = ['Odd', 'Even', 'Big', 'Small'];
const F_P_C_TYPE = ['Fish', 'Prawn', 'Crab'];
const isWeb = typeof document !== 'undefined';

const BetsDigitItem = ({
  type,
  options = [],
  isDigit = false,
  isSingle = false,
  onBets,
  mode,
  cartList = [],
  currentPrize,
  index = 0,
  rowIndex = 0,
  cartListShadow = [],
  hasSelected = [],
  disabledAll,
}: BetsTypeItemProps) => {
  const rowBackgroundColor = rowIndex % 2 === 0 ? '#DFE3ED' : 'transparent';

  // const {t} = useTranslation();
  // const betIsDisabled = (item: MixBetOpt) => {
  //   if (mode === LotteryMode['Two Side']) {
  //     const currentRow = cartList.find(
  //       pie =>
  //         pie.type === type &&
  //         pie.selectPrize === currentPrize &&
  //         pie.modeID === mode,
  //     );
  //     if (currentRow) {
  //       if (currentRow.value === 'Big' || currentRow.value === 'Small') {
  //         return item.value === 'Odd' || item.value === 'Even';
  //       } else {
  //         return item.value === 'Big' || item.value === 'Small';
  //       }
  //     }
  //   }
  //   return false;
  // };

  const getTWSType = (betItem: number) => {
    const TYPE_INDEX = (betItem - 1) % 4;
    const INDEX = Math.trunc((betItem - 1) / 4);
    return {
      type: DEFAULT[INDEX],
      value: SIDE_TYPE[TYPE_INDEX],
    };
  };

  const getSub = (v: string) => {
    if (v === 'Small' || v === 'Big') {
      return SIDE_TYPE.slice(2, 4);
    } else if (v === 'Even' || v === 'Odd') {
      return SIDE_TYPE.slice(0, 2);
    }
    return [];
  };

  const betHasSelect = (item: MixBetOpt, isDisabled: boolean = true) => {
    if (mode === LotteryMode['Two Side']) {
      const hasBuyRow = hasSelected.filter(
        pie =>
          pie.modeID === mode &&
          pie.tabID === currentPrize &&
          getTWSType(pie.betItem).type === type,
      );
      if (hasBuyRow.length > 0) {
        const INDEX_S = hasBuyRow.map(pie => (pie.betItem - 1) % 4);
        const checkV_S = INDEX_S.map(pie => SIDE_TYPE[pie]);
        if (!isDisabled) {
          return checkV_S.includes(item.value);
        } else {
          const diff = checkV_S.length === 2 ? checkV_S : getSub(checkV_S[0]);
          const arrayDifference = SIDE_TYPE.filter(
            pie => !diff.includes(pie),
          ).concat(checkV_S);
          return arrayDifference.includes(item.value);
        }
      }
    }
    if (mode === LotteryMode['1 Digit']) {
      const has = hasSelected.find(
        pie =>
          pie.modeID === mode &&
          pie.tabID === currentPrize &&
          pie.betNo === padZero(item.value, 4),
      );
      return Boolean(has);
    }
    if (mode === LotteryMode.FishPrawnCrab) {
      const has = hasSelected.find(
        pie =>
          pie.modeID === mode &&
          pie.tabID === currentPrize &&
          pie.betItem === F_P_C_TYPE.findIndex(p => p === item.value) + 1,
      );
      return Boolean(has);
    }
    return false;
  };

  const betIsSelected = (item: MixBetOpt) => {
    const isSpecial =
      mode === LotteryMode['Two Side'] ||
      mode === LotteryMode['1 Digit'] ||
      mode === LotteryMode.FishPrawnCrab;
    const target = isSpecial ? cartList : cartListShadow;
    const res = target.find(
      pie =>
        pie.type === type &&
        pie.modeID === mode &&
        pie?.value === item.value &&
        pie.selectPrize === currentPrize,
    );
    return Boolean(res);
  };

  const renderWebSingleDigitRow = (list: MixBetOpt[]) => {
    return (
      <div style={stylesWeb.digitSingleRow}>
        {list.map(pie => (
          <div style={stylesWeb.singleDigitCell} key={pie.label}>
            <BetsItem
              onItemPress={(v: BetsItemTarget | undefined) => {
                onBets?.(pie, v);
              }}
              disabled={disabledAll || betHasSelect(pie)}
              showDisabledOpacity={!disabledAll && betHasSelect(pie)}
              checked={betIsSelected(pie) || betHasSelect(pie)}
              isPrimary
              isDigit
              digit={pie.label}
              type={type}
            />
            <div style={stylesWeb.singleDigitRate}>{pie.odds}X</div>
          </div>
        ))}
      </div>
    );
  };

  const renderWebMultiDigitRow = (list: MixBetOpt[]) => {
    return (
      <div style={stylesWeb.digitRow}>
        {list.map(pie => (
          <div style={stylesWeb.digitCell} key={pie.label}>
            <BetsItem
              checked={betIsSelected(pie)}
              isDigit
              disabled={disabledAll}
              showDisabledOpacity={false}
              digit={pie.label}
              type={type}
              onItemPress={(v: BetsItemTarget | undefined) => {
                onBets?.(pie, v);
              }}
            />
          </div>
        ))}
      </div>
    );
  };

  if (isWeb) {
    return (
      <div
        style={{
          ...stylesWeb.rowWrap,
          backgroundColor: rowBackgroundColor,
        }}>
        {!isSingle ? <BetsLabel type={type} /> : null}
        <div style={stylesWeb.contentWrap}>
          {!isDigit ? (
            <div style={stylesWeb.optionOuter}>
              <div style={stylesWeb.optionInner}>
                {options.map((item, i) => {
                  return (
                    <BetsItem
                      onItemPress={(v: BetsItemTarget | undefined) => {
                        onBets?.(
                          {
                            ...item,
                            betItem: index * options.length + i,
                          },
                          v,
                        );
                      }}
                      disabled={disabledAll}
                      showDisabledOpacity={false}
                      checked={
                        betIsSelected(item) ||
                        betHasSelect(item, LotteryMode['Two Side'] !== mode)
                      }
                      key={i}
                      isDigit={isDigit}
                      rate={`${item.odds}X`}
                      digit={item.label}
                      type={type}
                    />
                  );
                })}
              </div>
            </div>
          ) : null}
          {isSingle && isDigit ? (
            <>
              {renderWebSingleDigitRow(options.slice(0, 5))}
              <div style={stylesWeb.singleDigitRowGap} />
              {renderWebSingleDigitRow(options.slice(5))}
            </>
          ) : null}
          {!isSingle && isDigit ? (
            <>
              {renderWebMultiDigitRow(options.slice(0, 5))}
              <div style={stylesWeb.digitRowGap} />
              {renderWebMultiDigitRow(options.slice(5))}
            </>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <View style={[styles.rowWrap, {backgroundColor: rowBackgroundColor}]}>
      {!isSingle && <BetsLabel type={type} />}

      <View style={theme.flex.flex1}>
        {!isDigit &&
          (isWeb ? (
            <div style={stylesWeb.optionOuter}>
              <div style={stylesWeb.optionInner}>
                {options.map((item, i) => {
                  return (
                    <BetsItem
                      onItemPress={(v: BetsItemTarget | undefined) => {
                        onBets?.(
                          {
                            ...item,
                            betItem: index * options.length + i,
                          },
                          v,
                        );
                      }}
                      disabled={disabledAll}
                      showDisabledOpacity={false}
                      checked={
                        betIsSelected(item) ||
                        betHasSelect(item, LotteryMode['Two Side'] !== mode)
                      }
                      key={i}
                      isDigit={isDigit}
                      rate={`${item.odds}X`}
                      digit={item.label}
                      type={type}
                    />
                  );
                })}
              </div>
            </div>
          ) : (
            <View style={[theme.flex.row, theme.flex.flex1, styles.optionWrap]}>
              {options.map((item, i) => {
                return (
                  <BetsItem
                    onItemPress={(v: BetsItemTarget | undefined) => {
                      onBets?.(
                        {...item, betItem: index * options.length + i},
                        v,
                      );
                    }}
                    disabled={disabledAll}
                    showDisabledOpacity={false}
                    checked={
                      betIsSelected(item) ||
                      betHasSelect(item, LotteryMode['Two Side'] !== mode)
                    }
                    key={i}
                    isDigit={isDigit}
                    rate={`${item.odds}X`}
                    digit={item.label}
                    type={type}
                  />
                );
              })}
            </View>
          ))}
        {isSingle && isDigit && (
          <>
            <View
              style={[theme.flex.row, theme.flex.flex1, theme.flex.between]}>
              {options.slice(0, 5).map((pie, _ii) => (
                <View style={[theme.flex.center]} key={_ii}>
                  <BetsItem
                    onItemPress={(v: BetsItemTarget | undefined) => {
                      onBets?.(pie, v);
                    }}
                    disabled={disabledAll || betHasSelect(pie)}
                    showDisabledOpacity={!disabledAll && betHasSelect(pie)}
                    checked={betIsSelected(pie) || betHasSelect(pie)}
                    isPrimary
                    isDigit
                    digit={pie.label}
                    type={type}
                  />
                  <Text fontWeight="500" style={[theme.margin.topxxs]}>
                    {pie.odds}X
                  </Text>
                </View>
              ))}
            </View>
            <View
              style={[
                theme.flex.row,
                theme.flex.flex1,
                theme.flex.between,
                theme.margin.tops,
              ]}>
              {options.slice(5).map((pie, _ii) => (
                <View style={[theme.flex.center]} key={_ii}>
                  <BetsItem
                    isPrimary
                    isDigit
                    digit={pie.label}
                    type={type}
                    disabled={disabledAll || betHasSelect(pie)}
                    showDisabledOpacity={!disabledAll && betHasSelect(pie)}
                    checked={betIsSelected(pie) || betHasSelect(pie)}
                    onItemPress={(v: BetsItemTarget | undefined) => {
                      onBets?.(pie, v);
                    }}
                  />
                  <Text fontWeight="500" style={[theme.margin.topxxs]}>
                    {pie.odds}X
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}
        {!isSingle && isDigit && (
          <>
            <View style={[theme.flex.row, theme.flex.flex1]}>
              {options.slice(0, 5).map(pie => (
                <View style={styles.digitCell} key={pie.label}>
                  <BetsItem
                    checked={betIsSelected(pie)}
                    isDigit
                    disabled={disabledAll}
                    showDisabledOpacity={false}
                    digit={pie.label}
                    type={type}
                    onItemPress={(v: BetsItemTarget | undefined) => {
                      onBets?.(pie, v);
                    }}
                  />
                </View>
              ))}
            </View>
            <View style={[theme.flex.row, theme.flex.flex1, theme.margin.tops]}>
              {options.slice(5).map(pie => (
                <View style={styles.digitCell} key={pie.label}>
                  <BetsItem
                    checked={betIsSelected(pie)}
                    isDigit
                    disabled={disabledAll}
                    showDisabledOpacity={false}
                    digit={pie.label}
                    type={type}
                    onItemPress={(v: BetsItemTarget | undefined) => {
                      onBets?.(pie, v);
                    }}
                  />
                </View>
              ))}
            </View>
          </>
        )}
      </View>
    </View>
  );
};

const styles = {
  rowWrap: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    paddingHorizontal: 12,
    paddingVertical: 12,
    overflow: 'visible' as const,
  },
  optionWrap: {
    gap: 8,
    overflow: 'visible' as const,
  },
  digitCell: {
    width: '20%' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    marginRight: -4,
    overflow: 'visible' as const,
  },
};

const stylesWeb: Record<string, React.CSSProperties> = {
  rowWrap: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0.75rem',
    overflow: 'visible',
  },
  contentWrap: {
    flex: 1,
    overflow: 'visible',
  },
  optionOuter: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible',
  },
  optionInner: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '0.4375rem',
    flex: 1,
    overflow: 'visible',
  },
  digitRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    overflow: 'visible',
  },
  digitRowGap: {
    height: '0.75rem',
  },
  digitCell: {
    width: '20%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '-0.25rem',
    overflow: 'visible',
  },
  digitSingleRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    overflow: 'visible',
  },
  singleDigitRowGap: {
    height: '0.5rem',
  },
  singleDigitCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  singleDigitRate: {
    marginTop: '0.25rem',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 500,
    color: '#31373D',
    textAlign: 'center',
  },
};

export default React.memo(BetsDigitItem);
